import {
  CreateBuildingRequest,
  FetchBuildingRequest,
  SetDefaultData,
  UpdateBuildingRequest,
  // FetchDiscountGroupRequest,
  UpdateField,
  // UpdateDiscountGroupRequest,
} from '../../../containers/digitization/digitization.actions'
import { getUpdateBuildingState } from '../../../containers/digitization/digitization.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import {
  Component,
  OnInit,
  OnDestroy,
  EventEmitter,
  Output,
  Input,
  SimpleChanges,
} from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Subject, Subscription, debounceTime } from 'rxjs'
import { List, Map } from 'immutable'
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms'
import {
  DetectAllLayersRequest,
  DetectLayerRequest,
  FetchActiveLayersRequest,
  SearchCommunitiesRequest,
  SearchStreetsRequest,
} from '@shared/shared.actions'
import {
  getActiveLayers,
  getDetectedLayer,
  getDetectedLayers,
  getSearchCommunitiesState,
  getSearchStreetsState,
} from '@shared/shared.select'
import { booleanToWord, calculateArea } from '@shared/shared.utils'
import { getSettingsState } from '@containers/settings/settings.selectors'
import { GeoJSON } from 'ol/format'

@Component({
  selector: 'update-building-modal',
  templateUrl: './update-building-modal.component.html',
  styleUrls: ['./update-building-modal.component.css'],
})
export class UpdateBuildingModalComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  public isLoading: boolean
  @Input() public isEditable: boolean
  @Input() public isCreate: boolean
  public form: FormGroup
  public layers: FormGroup
  @Input('feature') public feature: any
  @Input('geojson') public geojson: any
  @Output() public close: EventEmitter<any> = new EventEmitter()
  @Output() public editableChange: EventEmitter<any> = new EventEmitter()
  @Output() public formChange: EventEmitter<any> = new EventEmitter()
  public onStreetsAutocomplete$ = new Subject<string>()
  public streets: List<Map<string, any>>
  public communities: List<Map<string, any>>
  private streetsAutocomplete$: Subscription
  private searchStreetsState$: Subscription
  private searchCommunitiesState$: Subscription
  private communitiesAutocomplete$: Subscription
  private activeLayersState$: Subscription
  public onCommunitiesAutocomplete$ = new Subject<string>()
  public booleanToWord = booleanToWord
  public settings: any = {}
  private settings$: Subscription
  private detectLayerState$: Subscription
  private detectAllLayersState$: Subscription
  private interval: any

  constructor(
    public store: Store<any>,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
  ) {
    super()
  }

  ngAfterViewInit() {
    this.settings$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((state) => {
        this.settings = state.getIn(['data', 'units']).toJS()
      })
  }

  checkboxChanged() {
    // Do something when the checkbox state changes
  }

  ngOnInit() {
    this.layers = this.formBuilder.group({
      rows: this.formBuilder.array([]),
    })

    this.layers.valueChanges.subscribe(() => {
      const buildingLayerFeatures = this.activeLayers
        .map((row) => ({
          layerId: row.get('id').value,
          id: row.get('feature').value,
        }))
        .filter(({ id }) => !!id)
      this.formChange.emit(buildingLayerFeatures)
    })

    this.form = this.formBuilder.group({
      id: [null],
      area: [''],
      valid: [''],
      validReason: [''],
      street: [''],
      streetOther: [''],
      streetNumber: [''],
      community: [''],
      communityOther: [''],
      zone: [''],
      numberOfStories: [''],
      name: [''],
      geojson: [null],
      propertyId: [null],
      propertyCode: [null],
    })
    this.store.dispatch<any>(new SetDefaultData('updateBuilding'))
    this.state$ = this.store
      .pipe(select(getUpdateBuildingState))
      .subscribe((state) => {
        this.state = state
        const data = this.state.get('data').toJS()

        if (data.id && data.id !== this.form.get('id').value) {
          this.form.patchValue({
            ...data,
            geojson: data.feature ? JSON.stringify(data.feature || {}) : null,
          })
        }

        if (this.layers && data.buildingLayerFeatures) {
          this.activeLayers?.forEach((group) => {
            this.selectedDetectedLayer(null, group.get('id').value)
          })

          data.buildingLayerFeatures.forEach((row: any) => {
            if (row.layerFeature) {
              this.selectedDetectedLayer(
                row.layerFeature.id,
                row.layerFeature.layerId,
              )
            }
          })
        }

        this.isLoading = state.get('isLoading')
      })

    this.searchStreetsState$ = this.store
      .pipe(select(getSearchStreetsState))
      .subscribe((state) => {
        this.streets = state.get('data').toJS()
      })

    this.searchCommunitiesState$ = this.store
      .pipe(select(getSearchCommunitiesState))
      .subscribe((state) => {
        this.communities = state.get('data').toJS()
      })

    this.store.dispatch<any>(new SearchStreetsRequest(''))

    this.streetsAutocomplete$ = this.onStreetsAutocomplete$
      .pipe(debounceTime(500))
      .subscribe((keyword) => {
        if (keyword) {
          this.store.dispatch<any>(new SearchStreetsRequest(keyword))
        }
      })

    this.communitiesAutocomplete$ = this.onCommunitiesAutocomplete$
      .pipe(debounceTime(500))
      .subscribe((keyword) => {
        if (keyword) {
          this.store.dispatch<any>(new SearchCommunitiesRequest(keyword))
        }
      })

    this.activeLayersState$ = this.store
      .pipe(select(getActiveLayers))
      .subscribe((state) => {
        const rows = this.layers.get('rows') as FormArray

        rows.clear()

        state.toJS().forEach((layer: any) => {
          rows.push(
            this.formBuilder.group({
              name: [layer.name],
              id: [layer.id],
              features: [layer.features],
              feature: [null],
            }),
          )
        })

        this.interval = setInterval(() => {
          const data = this.state.get('data').toJS()

          if (this.layers && data.buildingLayerFeatures) {
            this.activeLayers?.forEach((group) => {
              this.selectedDetectedLayer(null, group.get('id').value)
            })

            data.buildingLayerFeatures.forEach((row: any) => {
              if (row.layerFeature) {
                this.selectedDetectedLayer(
                  row.layerFeature.id,
                  row.layerFeature.layerId,
                )
              }
            })

            clearInterval(this.interval)
          }
        })
      })

    this.detectLayerState$ = this.store
      .pipe(select(getDetectedLayer))
      .subscribe((state) => {
        if (!state.get('isLoading') && state.getIn(['data', 'layerId'])) {
          this.selectedDetectedLayer(
            state.getIn(['data', 'id']),
            state.getIn(['data', 'layerId']),
          )
        }
      })

    this.detectAllLayersState$ = this.store
      .pipe(select(getDetectedLayers))
      .subscribe((state) => {
        if (!state.get('isLoading')) {
          state
            .get('data')
            .toJS()
            .forEach((layer: any) => {
              this.selectedDetectedLayer(layer.featureId, layer.layerId)
            })
        }
      })

    const selectedId = this.feature ? this.feature.getId() : null

    if (selectedId) {
      this.store.dispatch<any>(new FetchBuildingRequest(selectedId))
      this.store.dispatch<any>(new SearchCommunitiesRequest(''))
      this.store.dispatch<any>(new FetchActiveLayersRequest())
    }
  }

  selectedDetectedLayer(id: any, layerId: any) {
    const layer = this.activeLayers?.find(
      (l) => l.get('id').value === layerId,
    ) as FormGroup

    if (layer) {
      layer.get('feature').setValue(id)
    }
  }

  getSelectedFeatureById(fid: any, features: any[]) {
    const feature = features?.find(({ id }) => id === fid)

    let label = null

    if (feature) {
      label = feature.label
    }

    return label
  }

  detect(id: string) {
    const json = new GeoJSON().writeGeometry(this.feature.getGeometry())

    this.store.dispatch<any>(
      new DetectLayerRequest({
        id,
        geoJson: JSON.parse(this.geojson || json),
      }),
    )
  }

  featuresWithNone(features: any[]) {
    return [{ id: null, label: 'None' }, ...features]
  }

  detectAll() {
    const json = new GeoJSON().writeGeometry(this.feature.getGeometry())

    this.store.dispatch<any>(
      new DetectAllLayersRequest({
        geoJson: JSON.parse(this.geojson || json),
      }),
    )
  }

  get activeLayers() {
    return this.layers?.get('rows')['controls'] as FormGroup[]
  }

  restoreForm() {
    const data = this.state.get('data').toJS()

    if (data.id) {
      this.form.patchValue(data)
    }
  }

  cancel() {
    this.restoreForm()
    this.editableChange.emit(false)
  }

  toggleEditable() {
    // this.isEditable = true
    this.editableChange.emit(true)
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.searchStreetsState$.unsubscribe()
    this.streetsAutocomplete$.unsubscribe()
    this.communitiesAutocomplete$.unsubscribe()
    this.searchCommunitiesState$.unsubscribe()

    if (this.activeLayersState$) {
      this.activeLayersState$.unsubscribe()
    }

    if (this.detectLayerState$) {
      this.detectLayerState$.unsubscribe()
    }

    if (this.detectAllLayersState$) {
      this.detectAllLayersState$.unsubscribe()
    }

    if (this.settings$) {
      this.settings$.unsubscribe()
    }
  }

  validation() {
    const data = this.form.value
    const rules = {
      // area: 'required',
      // street: 'required',
      // streetOther: 'string',
      // streetNumber: 'required',
      // community: 'required',
      // communityOther: 'string',
      // numberOfStories: 'required',
      // name: 'required',
    }
    const validator = new Validator(data, rules)

    validator.setAttributeNames({
      numberOfStories: 'number of stories',
      communityOther: 'community other',
      streetNumber: 'street number',
      streetOther: 'street other',
    })

    return validator
  }

  public closeModal() {
    this.close.emit()
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.form.value
    const selectedId = this.feature ? this.feature.getId() : null

    if (validation.passes()) {
      const buildingLayerFeatures = this.activeLayers?.map((row) => ({
        layerId: row.get('id').value,
        id: row.get('feature').value,
      }))

      if (!this.isCreate) {
        this.store.dispatch(
          new UpdateBuildingRequest(selectedId, {
            ...payload,
            buildingLayerFeatures,
          }),
        )
      } else {
        this.store.dispatch(
          new CreateBuildingRequest({
            ...payload,
            buildingLayerFeatures,
          }),
        )
      }
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'updateBuilding',
        ),
      )
    }
  }

  public handlePolygonChange(val: string | null) {
    this.form.get('geojson').setValue(val)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.geojson && this.form) {
      const area = calculateArea(this.feature.getGeometry(), this.settings)

      this.form.get('area').setValue(area)
      this.form.get('geojson').setValue(changes.geojson.currentValue)
    }

    if (changes.isCreate && changes.isCreate.currentValue) {
      if (this.form) {
        this.form.reset()
      }

      this.activeLayers?.forEach((fg) => {
        fg.get('feature').setValue(null)
      })
    }

    if (
      changes.feature &&
      changes.feature.currentValue &&
      changes.feature.currentValue.getId() !==
        changes.feature.previousValue?.getId()
    ) {
      this.editableChange.emit(false)

      if (this.form) {
        this.form.reset()
      }

      if (
        changes.feature.previousValue?.getId() &&
        changes.feature.currentValue.getId()
      ) {
        this.store.dispatch<any>(
          new FetchBuildingRequest(changes.feature.currentValue.getId()),
        )
      }
    }
  }
}
